import {Project} from "../api/Project";


export const portfolioProject: Project = {
    id: 7,
    title: 'Chirag Gupta\'s Portfolio',
    description: 'This project gives a brief about me and my work till now.',
    link: 'https://chiraggupta.web.app/',
    image: 'favicon.ico',
    startDate: 'June 2020',
    completeDate: 'June 2020',
    hidden: false,
    technologies: {
        backend: [
            "Node.js"
        ],
        frontend: [
            "React.js",
            "NextUI",
        ]
    }
};
